import { useParams } from "react-router";
import { usePortfolio, useScatter } from "../api";
import { ScatterItem } from "@iliotech/widgets";
import { ScatterDtoV3 } from "@iliotech/generated-api-v3";
import {
  ALLOCATION_COLORS,
  BENCHMARK_COLOR,
  IGlobalPeriodContext,
  PORTFOLIO_COLOR,
  useReferenceData,
} from "../../main";
import { Period } from "@iliotech/generated-api-v3";

export const useRiskReturnPage = (overridePeriod?: IGlobalPeriodContext) => {
  const { portfolioId = "" } = useParams();
  const portfolio = usePortfolio(portfolioId);

  const { getAssetLabel } = useReferenceData();
  const { data } = useScatter(portfolioId, undefined, overridePeriod);

  const portfolioInfo = portfolio?.data?.data;
  const assets: ScatterItem[] =
    data?.data?.assets.map((asset) => {
      return {
        category: getAssetLabel(asset.name),
        xField: asset.volatility!,
        yField: asset.periodReturn!,
        color: ALLOCATION_COLORS[asset.name],
      };
    }) || [];
  const items: ScatterItem[] = [
    ...assets,
    {
      category: "Portfolio",
      xField: data?.data?.portfolio?.volatility!,
      yField: data?.data?.portfolio?.periodReturn!,
      value: data?.data?.benchmark?.totalMarketValueBase!,
      color: PORTFOLIO_COLOR,
    },
    {
      category: "Benchmark",
      xField: data?.data?.benchmark?.volatility!,
      yField: data?.data?.benchmark?.periodReturn!,
      value: data?.data?.benchmark?.totalMarketValueBase!,
      color: BENCHMARK_COLOR,
    },
  ];

  const tableData = [
    {
      name: "Portfolio",
      return: data?.data?.portfolio.periodReturn,
      volatility: data?.data?.portfolio.volatility,
      marketVal: data?.data?.portfolio.totalMarketValueBase,
      enabled: true,
    },
    {
      name: "Benchmark",
      return: data?.data?.benchmark.periodReturn,
      volatility: data?.data?.benchmark.volatility,
      enabled: true,
    },
    ...(data?.data?.assets || []).map((asset) => ({
      name: asset.name,
      return: asset.periodReturn,
      volatility: asset.volatility,
      marketVal: asset.totalMarketValueBase,
      enabled: true,
    })),
  ];

  const getItemValue = (category: string) => {
    console.log({ category });
    if (category === "Portfolio") {
      return data?.data?.portfolio?.totalMarketValueBase;
    }
    if (category === "Benchmark") {
      return data?.data?.benchmark?.totalMarketValueBase;
    }
    return (
      data?.data?.assets.find((asset) => asset.name === category)
        ?.totalMarketValueBase || 0
    );
  };
  return { portfolioInfo, items, tableData, getItemValue };
};
